import request from '@/utils/http'

const PREFIX = '/systemDashboard'

const systemDashboard = {
  basis() {
    return request(
      `${PREFIX}/basis`,
      'get'
    )
  },

  logDetail() {
    return request(
      `${PREFIX}/logDetail`,
      'get'
    )
  },

  trend(param) {
    return request(
      `${PREFIX}/trend`,
      'post',
      param
    )
  },

  top() {
    return request(
      `${PREFIX}/top`,
      'get'
    )
  },

  top7() {
    return request(
      `${PREFIX}/dateTop`,
      'get'
    )
  }
}

export default systemDashboard
